import React from 'react';

interface Props {
  width?: string;
  height?: string;
  strokeColor?: string;
}

/**
 * PLAT-11877 — the captions glyph for the transcript's view switch: a speech
 * bubble reading "CAP", after the subtitle-badge convention ("SUB" in a
 * bubble). The letters are the icon's mark, not a UI label, so they sit
 * inside the drawing at a fixed size. Stroke and letters take
 * `currentColor`, so the segment's active / inactive ink colours both.
 * Stroke 1.9 in a 30-unit box: at the sidebar's 24px it lands at the
 * siblings' ~1.5px, at the view switch's 20px a touch lighter.
 */
const CaptionsBubbleIcon = ({
  width = '20',
  height = '16',
  strokeColor = 'currentColor',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Bubble: rounded box with a small tail at the bottom left of centre. */}
    <path
      d="M4 2.5h22a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H13.5L10.5 22l-1.5-3.5H4a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2Z"
      stroke={strokeColor}
      strokeWidth="1.9"
      strokeLinejoin="round"
    />
    <text
      x="15"
      y="14.4"
      textAnchor="middle"
      fill={strokeColor}
      fontFamily="var(--font-primary), system-ui, sans-serif"
      fontSize="9.5"
      fontWeight="600"
      letterSpacing="0.2"
    >
      CAP
    </text>
  </svg>
);

export default CaptionsBubbleIcon;
